module.exports = new __parcel__URL__("capacity-preview-dark.f2f1c65d.svg").toString();